module.exports = __webpack_public_path__ + "static/media/schedule_Overview.10fcc5b3.png";